import { jsx as _jsx } from "react/jsx-runtime";
import React, { memo } from 'react';
const justifyClassMap = {
    between: 'justify-content-between',
    end: 'justify-content-end',
    center: 'justify-content-center',
    start: 'justify-content-start',
};
export const PRow = memo(({ children, justify, style, className }) => {
    const justifyClass = justify ? justifyClassMap[justify] ?? '' : '';
    const classes = ['grid', justifyClass, className].filter(Boolean).join(' ');
    return (_jsx("div", { style: style, className: classes, children: children }));
});
export default PRow;
